module.exports = __webpack_public_path__ + "media/amp_version/google-play-df51d57b.svg";